import React from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import * as routes from "../../routes/routeConstants/appRoutes";
import Boards from "./Boards";
import Classes from "./Classes";
import Subjects from "./Subjects";
import Chapters from "./Chapters";

const CourseStructureRouter = () => {
    return (
        <Switch>
            <Redirect exact strict from={routes.COURSE_STRUCTURE} to={routes.COURSE_BOARDS} />
            <Route exact path={routes.COURSE_BOARDS} component={() => <Boards />} />
            <Route exact path={routes.COURSE_CLASS} component={() => <Classes />} />
            <Route exact path={routes.COURSE_SUBJECTS} component={() => <Subjects />} />
            <Route exact path={routes.COURSE_CHAPTERS} component={() => <Chapters />} />
        </Switch>
    )
}

export default CourseStructureRouter;
